module.exports = __webpack_public_path__ + "img/kino_kunsthalle_3_a.40575d32.jpg";